import InquiryToCustomer, { RequestedDocument } from "@/src/types/Entities/InquiryToCustomer";
import callIcon from "@/src/assets/icons/generic/IconCallClock";
import iconAssistent from "@/src/assets/icons/serviceOverview/IconAssistant";
import dayjs from "dayjs";

export const allowMissingDocument = (documentData: RequestedDocument, inquiryToCustomer: InquiryToCustomer) => {
  // fallback for deprecated field. remove this in january 2024
  if (documentData.mandatory) {
    return false;
  }

  switch (documentData.mandatoryType) {
    case "full":
      return false;
    case "deadlineDependent":
      return dayjs() > dayjs(inquiryToCustomer.deadline);
    default:
      return true;
  }
};

export const getInquiriesBoxHeadingContent = (inquiries: InquiryToCustomer[]) => {
  const hasAppointmentInquiry = inquiries.some((inquiry) => inquiry.inquiryType === "appointment");
  const hasOtherInquiry = inquiries.some((inquiry) => inquiry.inquiryType !== "appointment");

  if (hasAppointmentInquiry && !hasOtherInquiry) {
    return { headline: "Termin vereinbaren", icon: callIcon };
  }

  return { headline: "Rückmeldung geben", icon: iconAssistent };
};
